import styled from 'styled-components';

export const IconContainer = styled.div`
  display: flex;
  margin-right: 12px;
  height: 100%;
  align-items: center;
`;
